(function () {
  'use strict';

  function initCapriPDP(root) {
    var variantsData = JSON.parse(root.querySelector('[data-capri-variants]').textContent);
    var moneyFormat = root.getAttribute('data-money-format') || '€{{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return moneyFormat.replace('{{amount}}', amount);
    }

    function findVariant(color, size) {
      for (var i = 0; i < variantsData.length; i++) {
        if (variantsData[i].color === color && variantsData[i].size === size) return variantsData[i];
      }
      return null;
    }

    var colors = Array.from(new Set(variantsData.map(function (v) { return v.color; })));
    var sizes = Array.from(new Set(variantsData.map(function (v) { return v.size; })));

    var state = {
      color: root.getAttribute('data-default-color') || colors[0],
      size: root.getAttribute('data-default-size') || sizes[0],
      tier: 1
    };

    var tierConfig = {
      1: { qty: 1, label: root.getAttribute('data-tier1-label') },
      3: { qty: 3, label: root.getAttribute('data-tier3-label') },
      6: { qty: 6, label: root.getAttribute('data-tier6-label') }
    };

    // --- Gallery ---
    var mainImg = root.querySelector('.capri-gallery__main img');
    var thumbs = root.querySelectorAll('.capri-gallery__thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        mainImg.src = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
      });
    });

    // --- Color swatches ---
    var colorLabel = root.querySelector('[data-capri-color-label]');
    var colorSwatches = root.querySelectorAll('.capri-colors__swatch');
    colorSwatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.disabled) return;
        state.color = swatch.getAttribute('data-color');
        colorSwatches.forEach(function (s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');
        if (colorLabel) colorLabel.textContent = state.color;
        syncPackRowOptions();
        updateAvailability();
      });
    });

    // --- Size select ---
    var sizeSelect = root.querySelector('[data-capri-size-select]');
    var sizeLabel = root.querySelector('[data-capri-size-label]');
    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        state.size = sizeSelect.value;
        if (sizeLabel) sizeLabel.textContent = state.size;
        updateAvailability();
      });
    }

    function updateAvailability() {
      var variant = findVariant(state.color, state.size);
      var atc = root.querySelector('.capri-atc');
      var errorEl = root.querySelector('.capri-atc-error');
      if (!variant || !variant.available) {
        if (state.tier === 1) {
          atc.disabled = true;
          errorEl.textContent = 'Esta combinación de color y talla no está disponible.';
          errorEl.classList.add('is-visible');
        }
      } else {
        atc.disabled = false;
        errorEl.classList.remove('is-visible');
      }
    }

    // --- Tier selection ---
    var tierEls = root.querySelectorAll('.capri-tier');
    var packConfigEls = root.querySelectorAll('[data-capri-pack-config]');
    var atcTotalEl = root.querySelector('[data-capri-atc-total]');

    function renderPackConfig(qty) {
      packConfigEls.forEach(function (el) { el.hidden = true; });
      if (qty === 1) return;
      var target = root.querySelector('[data-capri-pack-config="' + qty + '"]');
      if (!target) return;
      target.hidden = false;
      var rowsContainer = target.querySelector('[data-capri-pack-rows]');
      rowsContainer.innerHTML = '';
      for (var i = 0; i < qty; i++) {
        var row = document.createElement('div');
        row.className = 'capri-pack-config__row';
        row.innerHTML =
          '<span class="capri-pack-config__index">#' + (i + 1) + '</span>' +
          '<select data-pack-color></select>' +
          '<select data-pack-size></select>';
        var colorSel = row.querySelector('[data-pack-color]');
        var sizeSel = row.querySelector('[data-pack-size]');
        colors.forEach(function (c) {
          var opt = document.createElement('option');
          opt.value = c; opt.textContent = c;
          if (c === state.color) opt.selected = true;
          colorSel.appendChild(opt);
        });
        sizes.forEach(function (s) {
          var opt = document.createElement('option');
          opt.value = s; opt.textContent = s;
          if (s === state.size) opt.selected = true;
          sizeSel.appendChild(opt);
        });
        rowsContainer.appendChild(row);
      }
    }

    function syncPackRowOptions() {
      // no-op placeholder: rows keep independent selections once rendered
    }

    tierEls.forEach(function (tierEl) {
      tierEl.addEventListener('click', function () {
        var qty = parseInt(tierEl.getAttribute('data-tier-qty'), 10);
        state.tier = qty;
        tierEls.forEach(function (t) { t.classList.remove('is-selected'); });
        tierEl.classList.add('is-selected');
        renderPackConfig(qty);
        updateAtcLabel();
      });
    });

    function updateAtcLabel() {
      var cfg = tierConfig[state.tier];
      if (atcTotalEl && cfg) atcTotalEl.innerHTML = cfg.label + ' <i class="ph ph-arrow-right"></i>';
    }
    updateAtcLabel();

    // --- Accordions (features/shipping) ---
    root.querySelectorAll('.capri-accordion__item').forEach(function (item) {
      var summary = item.querySelector('.capri-accordion__summary');
      summary.addEventListener('click', function () {
        item.classList.toggle('is-open');
      });
    });

    // --- FAQ (lives outside the .capri-pdp root, so bind at document level) ---
    document.querySelectorAll('.capri-faq__item').forEach(function (item) {
      var q = item.querySelector('.capri-faq__q');
      q.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        document.querySelectorAll('.capri-faq__item').forEach(function (i) { i.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });

    // --- Pack discount countdown timer (10 minutes, loops) ---
    var timerEl = document.querySelector('[data-capri-timer]');
    if (timerEl) {
      var DURATION_MS = 10 * 60 * 1000;
      var storageKey = 'capriPackTimerDeadline';
      var deadline = parseInt(sessionStorage.getItem(storageKey), 10);
      if (!deadline || deadline <= Date.now()) {
        deadline = Date.now() + DURATION_MS;
        sessionStorage.setItem(storageKey, String(deadline));
      }
      var tick = function () {
        var remaining = deadline - Date.now();
        if (remaining <= 0) {
          deadline = Date.now() + DURATION_MS;
          sessionStorage.setItem(storageKey, String(deadline));
          remaining = DURATION_MS;
        }
        var totalSeconds = Math.floor(remaining / 1000);
        var minutes = Math.floor(totalSeconds / 60);
        var seconds = totalSeconds % 60;
        timerEl.textContent = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
      };
      tick();
      setInterval(tick, 1000);
    }

    // --- Add to cart ---
    var atcButton = root.querySelector('.capri-atc');
    var errorEl = root.querySelector('.capri-atc-error');

    atcButton.addEventListener('click', function () {
      var items = [];

      if (state.tier === 1) {
        var variant = findVariant(state.color, state.size);
        if (!variant || !variant.available) {
          errorEl.textContent = 'Esta combinación de color y talla no está disponible.';
          errorEl.classList.add('is-visible');
          return;
        }
        items.push({ id: variant.id, quantity: 1 });
      } else {
        var configEl = root.querySelector('[data-capri-pack-config="' + state.tier + '"]');
        var rows = configEl.querySelectorAll('.capri-pack-config__row');
        var invalid = false;
        rows.forEach(function (row) {
          var c = row.querySelector('[data-pack-color]').value;
          var s = row.querySelector('[data-pack-size]').value;
          var v = findVariant(c, s);
          if (!v || !v.available) { invalid = true; return; }
          items.push({ id: v.id, quantity: 1 });
        });
        if (invalid) {
          errorEl.textContent = 'Alguna combinación seleccionada en el pack no está disponible.';
          errorEl.classList.add('is-visible');
          return;
        }
      }

      errorEl.classList.remove('is-visible');
      atcButton.disabled = true;
      var originalText = atcButton.innerHTML;
      atcButton.innerHTML = 'Añadiendo...';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          window.location.href = window.Shopify.routes.root + 'checkout';
        })
        .catch(function (err) {
          atcButton.disabled = false;
          atcButton.innerHTML = originalText;
          errorEl.textContent = (err && err.description) || 'No se pudo añadir al carrito. Inténtalo de nuevo.';
          errorEl.classList.add('is-visible');
        });
    });

    updateAvailability();

    // --- Reset button state when page is restored from back/forward cache ---
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        atcButton.disabled = false;
        errorEl.classList.remove('is-visible');
        updateAtcLabel();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-capri-pdp]').forEach(initCapriPDP);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
